import userService from "../services/user-service";
import axios from "axios";

export const AUTH_MESSAGE_KEY = "authentication-message";

export const authProvider = {

    async checkIsAuthenticate() {
        const user = JSON.parse(window.localStorage.getItem("user"));
        if (!user) {
            return false;
        }

        axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;
        const validation = await userService.validateUser();

        if (!validation.authenticated) {
            window.sessionStorage.setItem(AUTH_MESSAGE_KEY, validation.message);
            window.localStorage.removeItem("user");
            delete axios.defaults.headers.common['Authorization'];
        }

        return validation.authenticated;
    },
};
